import { FormTextArea } from "../../../helpers/AdminHelper";
import { memo } from "react";

const ProjectDescription = ({ project, updateProject }) => {
  return (
    <>
      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-white">
          Project Description
        </h2>
        <p className="text-sm text-slate-400">
          Describe the project, the challenges faced, the solution implemented,
          and the final outcome.
        </p>
      </div>
      <div className="space-y-6">
        <FormTextArea
          label="Short Description"
          rows={2}
          placeholder="Briefly summarize the project in 1–2 sentences."
          value={project.shortDescription}
          onChange={(e) => updateProject("shortDescription", e.target.value)}
        />

        <FormTextArea
          label="Project Description"
          rows={5}
          placeholder="Provide a detailed overview of the project."
          value={project.description}
          onChange={(e) => updateProject("description", e.target.value)}
        />

        <FormTextArea
          label="Project Challenge"
          rows={4}
          placeholder="Describe the key challenges encountered during the project."
          value={project.challenge}
          onChange={(e) => updateProject("challenge", e.target.value)}
        />

        <FormTextArea
          label="Solution"
          rows={4}
          placeholder="Explain how your team addressed the challenges."
          value={project.solution}
          onChange={(e) => updateProject("solution", e.target.value)}
        />

        <FormTextArea
          label="Project Result"
          rows={4}
          placeholder="Describe the final outcome of the project."
          value={project.result}
          onChange={(e) => updateProject("result", e.target.value)}
        />
      </div>
    </>
  );
};

export default memo(ProjectDescription);
